import { create } from "zustand";

export type ToastType = "error" | "success" | "info" | "warning";

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  action?: {
    label: string;
    onClick: () => void;
  };
}

interface ToastState {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, "id">) => string; // returns id
  removeToast: (id: string) => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],

  addToast: (toastInput) => {
    const id = `${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;
    const toast: Toast = { id, ...toastInput } as Toast;
    set((state) => ({ toasts: [...state.toasts, toast] }));

    // Auto-dismiss after 5s by default (not for info maybe?).
    setTimeout(() => {
      get().removeToast(id);
    }, 5000);

    return id;
  },

  removeToast: (id) => {
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
}));
